<template>
  <transition name="fade">
    <div v-if="show" class="cookie-settings-overlay">
      <div class="cookie-settings-modal">
        <div class="cookie-settings-header">
          <h3>Cookie Settings</h3>
          <button @click="close" class="close-button">&times;</button>
        </div>

        <div class="cookie-settings-content">
          <p class="settings-description">
            We use cookies to ensure the proper functioning of our website and
            to enhance your experience. You can choose which cookies you want to
            allow.
          </p>

          <div class="cookie-category">
            <div class="category-header">
              <div>
                <h4>Essential Cookies</h4>
                <p>
                  These Cookies are essential to the operation of the Services
                  and enable you to use their features. Without these Cookies,
                  We cannot provide the Services you have requested.
                </p>
              </div>
              <div class="toggle-container">
                <input
                  type="checkbox"
                  id="authentication"
                  v-model="preferences.authentication"
                />
                <label for="authentication" class="toggle"></label>
              </div>
            </div>
          </div>
        </div>

        <div class="cookie-settings-footer">
          <button @click="savePreferences" class="save-button">
            Save Preferences
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CookieSettings",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initialPreferences: {
      type: Object,
      default: () => ({
        authentication: true,
      }),
    },
  },
  data() {
    return {
      preferences: { ...this.initialPreferences },
    };
  },
  methods: {
    savePreferences() {
      try {
        console.log("Saving cookie preferences:", this.preferences);
        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";
        // For consistency, use the same approach as Overview.vue
        this.$cookies.set(
          "cookie-consent",
          this.preferences.authentication ? "accepted" : "declined",
          "365d",
          "/",
          isLocalhost ? "" : ".playcourt.id",
          true,
          "Lax"
        );
        console.log(
          "Cookie consent set to:",
          this.preferences.authentication ? "accepted" : "declined"
        );
        this.$emit("save", this.preferences);
        this.close();
      } catch (error) {
        console.error("Error saving cookie preferences:", error);
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cookie-settings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.cookie-settings-modal {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.cookie-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.cookie-settings-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #555;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cookie-settings-content {
  padding: 20px;
}

.settings-description {
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
}

.cookie-category {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.cookie-category:last-child {
  border-bottom: none;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-header h4 {
  margin: 0 0 5px 0;
  font-size: 16px;
  font-weight: 500;
}

.category-header p {
  margin: 0;
  font-size: 13px;
  color: #666;
}

.toggle-container {
  position: relative;
}

.toggle-container.disabled {
  opacity: 0.6;
}

.toggle-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle {
  display: block;
  width: 44px;
  height: 22px;
  background-color: #ccc;
  border-radius: 22px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

input[type="checkbox"]:checked + .toggle {
  background-color: #0078d7;
}

input[type="checkbox"]:checked + .toggle::after {
  transform: translateX(22px);
}

.cookie-settings-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.save-button {
  background-color: #0078d7;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.save-button:hover {
  background-color: #006bc0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
